<template>
  <div class="question-block-content">
    <img
      :src="closeIcon"
      class="close-btn"
      alt="close button"
      @click="openQuizExitDialog"
    />
    <div class="questionWrapper-block-answer">
      <div
        v-if="showBackButton"
        class="questionWrapper-block-answer-back-button"
        @click="back"
      >
        <v-btn
          class="questionWrapper-block-answer-back-exit-btn"
          elevation="0"
          block
        >
          <img
            :src="backArrowIcon"
            alt="back"
            width="16"
            height="16"
          >
          <span class="questionWrapper-block-answer-back-button-text">
            {{ $t('common.back2') }}
          </span>
        </v-btn>
      </div>
      <div class="questionWrapper">
        <messenger-form
          v-if="activeQuestion.index === 4"
          @handleDownloadBrowser="handleDownloadBrowser"
          @close="close"
        />

        <!-- Answer Buttons -->
        <div
          v-else
          :class="answersWrapperClass"
        >
          <button
            v-for="(answer, ind) in activeQuestion.answers"
            :key="ind"
            :class="{ active: answer.selected }"
            @click="select(answer.value)"
          >
            <img
              v-if="answer.emoji"
              :src="require(`@/assets/quiz/emojis/${answer.emoji}`)"
              alt="emoji"
            >
            <div
              v-if="$te(`quiz.${answer.text}`)"
              class="answersWrapper-items"
            >
              <p class="answersWrapper-item answersWrapper-item-title">
                {{ $t(`quiz.${answer.text}`) }}
              </p>
              <p
                v-if="answer.textDescription"
                class="answersWrapper-item answersWrapper-item-description"
              >
                {{ $t(`quiz.${answer.textDescription}`) }}
              </p>
            </div>
            <span v-else>
               {{ answer.text }}
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { messengerMixin } from '@/mixins/quizMessengers'
import MessengerForm from '@/components/quiz/MessengerForm.vue'
import closeIcon from '@/assets/quiz/close.svg'
import backArrowIcon from '@/assets/quiz/backArrow.svg'

export default {
  name: 'QuizAnswers',
  components: { MessengerForm },
  mixins: [messengerMixin],

  props: {
    activeQuestion: {
      type: Object,
      default: () => ({})
    },
    showBackButton: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      sendMessengerName: '',
      closeIcon,
      backArrowIcon
    }
  },

  computed: {
    answersWrapperClass() {
      const baseClass = 'answersWrapper';

      const formattedAmplitudeName = this.activeQuestion.amplitudeName
        ? this.activeQuestion.amplitudeName.replace(/\s+/g, '_')
        : '';

      const isSmall =
        this.activeQuestion.index === 1 ||
        (this.activeQuestion.index === 2 && this.activeQuestion.amplitudeName === 'quiz additional');

      const sizeClass = isSmall
        ? 'small-buttons-quiz-answers'
        : 'large-buttons-quiz-answers';

      return [baseClass, formattedAmplitudeName, sizeClass].filter(Boolean).join(' ');
    }
  },

  methods: {
    back() {
      this.$emit('back');
    },

    select(answerValue) {
      this.$emit('select', answerValue);
    },

    handleDownloadBrowser(messengerContact, selectedMessenger) {
      this.close(messengerContact, selectedMessenger)
      this.$emit('handleClick');
    },

    async close(messengerContact, selectedMessenger) {
      if (!messengerContact) {
        return this.$emit('close');
      }

      this.sendMessengerName = this.getMessengerName(selectedMessenger);

      const payload = {
        messenger: this.sendMessengerName,
        messengerIdentifier: messengerContact,
        action: 'quiz',
      };

      await this.api.post('/user/contact', payload);

      this.$emit('close');
    },

    openQuizExitDialog() {
      this.$store.dispatch('main/openDialog', 'quizLeavePrompt')
    }
  }
};
</script>

<style lang="scss" scoped>
.question-block-content {
  width: 50%;
  height: 100%;
  display: flex;
  padding: 48px 100px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  align-self: stretch;
}

.question-block-content img.close-btn {
  position: absolute;
  right: 30px;
  top: 30px;
  cursor: pointer;
  transition: opacity 0.15s;
}

.question-block div.top-block img.close-btn:hover {
  opacity: 1;
}

.questionWrapper-block-answer {
  width: 100%;
  max-width: 550px;
  min-width: 550px;
}

.questionWrapper-block-answer-back-button {
  cursor: pointer;
  gap: 6px;
  margin-bottom: 32px;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  color: var(--v-text-secondary-base);
  padding: 6px 12px;
}

.questionWrapper-block-answer-back-button .questionWrapper-block-answer-back-exit-btn{
  width: inherit;
  background-color: transparent;
  display: flex;
  justify-content: flex-start;
  min-width: inherit!important;
  border-radius: 8px;
  letter-spacing: normal;
}

.questionWrapper-block-answer-back-button-text {
  margin-left: 6px;
  text-transform: capitalize;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  color: var(--v-secondary-button-tertiary-foreground-default-base);
}

.questionWrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 48px;
  align-self: stretch;
}

.questionWrapper-container {
  width: 100%;
}

.answersWrapper {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  max-width: 600px;
}

.small-buttons-quiz-answers button {
  max-width: 265px;
  min-height: 86px;
}

.large-buttons-quiz-answers button {
  max-width: 550px;
}

.answersWrapper-items .answersWrapper-item {
  display: flex;
  text-align: start;
  margin-bottom: 0;
}

.answersWrapper-items .answersWrapper-item-title {
  margin-bottom: 2px;
}

.answersWrapper-item-description {
  color: var(--v-text-caption-base);
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

button {
  border-radius: 16px;
  width: 100%;
  cursor: pointer;
  color: var(--v-text-primary-base);
  display: flex;
  padding: 20px 28px;
  align-items: center;
  gap: 12px;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  box-shadow: 0px 24px 30px -24px rgba(208, 206, 217, 0.40), 0px 0px 0px 1px rgba(61, 59, 53, 0.08), 0px 2px 6px 0px rgba(61, 59, 53, 0.06);
}

button:hover {
  background: var(--v-background-primary-hover-base);
}

@media (max-width: 1200px) {
  .question-block-content {
    width: 100%;
    align-items: center;
    padding: 24px 16px 60px 16px;
  }

  .small-buttons-quiz-answers button {
    max-width: 550px;
    min-height: 86px;
  }

  .questionWrapper-block-answer {
    width: 100%;
    max-width: 550px;
    min-width: unset;
  }

  .question-block-content img.close-btn {
    top: 48px;
    right: 48px;
  }

  .question-block-content {
    justify-content: initial;
    flex: initial;
  }

  .questionWrapper-block-answer-back-button {
    margin-bottom: 16px;
  }

  .questionWrapper {
    align-items: center;
    gap: 24px;
  }

  .answersWrapper {
    gap: 16px;
  }
}
</style>
